import { authorizationService } from '@/data/services/authorization/authorization-service'

/**
 * Loads authorization detail data for the authorization detail page
 * Aggregates all required data: authorization, history, skills, and labels
 * @param authorizationId - The authorization ID to load
 */
export async function loadAuthorizationDetail(authorizationId: string) {
  return authorizationService.fetchAuthorizationDetail(Number(authorizationId))
}
